import Phone from '@hc-frontend/core-icons/kit/phone';
import { usePhoneCampaign } from '@hc-frontend/core-ui';
import { CallCta } from '@hc-frontend/shells-shared';

export default function CallCampaignButton() {
  const phoneCampaign = usePhoneCampaign();

  if (phoneCampaign) {
    return (
      <CallCta
        phoneCampaign={phoneCampaign}
        className="flex flex-wrap w-full items-center justify-center gap-12-12"
      >
        <span className="text-pretty">{`${phoneCampaign.phoneNumber} (${phoneCampaign.tty})`}</span>
        <Phone width={24} height={24} aria-hidden="true" />
      </CallCta>
    );
  }
  return null;
}
